import { ProgressSpinner } from "primereact/progressspinner";

export const FullLoading = ({ loadingState, message = "" }) => {
  const renderComponent = () => {
    return (
      <div
        className="flex h-full w-full absolute z-50 bg-white opacity-90 justify-center content-center items-center flex-col"
        data-testid="full-loading-component"
      >
        <ProgressSpinner mode="indeterminate" className="flex w-full h-8 " />
        {message !== "" ? (
          <span className="font-bold text-lg">{message}</span>
        ) : null}
      </div>
    );
  };

  const show = loadingState;

  return <>{show ? renderComponent() : null}</>;
};
